<template>
    <Dialog
        v-if="modals.add_creator_to_modal.is_open"
        id="add-creator-to-modal"
        :open="modals.add_creator_to_modal.is_open"
        @update:open="$store.commit('modal:close', 'add_creator_to_modal')"
    >
        <DialogContent :class="'max-w-4xl px-1'">
            <DialogHeader>
                <DialogTitle :class="'pl-5'">Add Creators To...</DialogTitle>
            </DialogHeader>
            <Separator />
            <AddCreatorMenu
                v-if="modals.add_creator_to_modal.is_open"
                :superviews="modals.add_creator_to_modal.superviews"
                :platform-id="modals.add_creator_to_modal.platform_id"
                :default-all-platforms="modals.add_creator_to_modal.default_all_platforms"
                :creator-platforms="modals.add_creator_to_modal.creator_platforms"
                :modal-open="modals.add_creator_to_modal.is_open"
            />
        </DialogContent>
    </Dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import AddCreatorMenu from '../actions/AddCreatorMenu.vue'

export default {
    components: {
        // eslint-disable-next-line
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        Separator,
        AddCreatorMenu,
    },

    data() {
        return {}
    },

    computed: {
        ...mapGetters(['modals']),
    },

    methods: {},
}
</script>
